import {AppLayoutToolbar, BreadcrumbGroup, TopNavigation} from "@cloudscape-design/components";
import logo from './logo192.png'
import {signOutRedirect} from "../../utils/session";
import {useAuth} from "react-oidc-context";
import {useNavigate, Outlet} from "react-router-dom";


export const BaseLayout = (props) => {
    const auth = useAuth();
    const navigate = useNavigate();

    async function handleButtonClick(event) {
        if (event.detail.id === 'signout') {
            await signOutRedirect(auth)
        }
    }

    function buildBreadcrumbs() {
        const paths = window.location.hash.split('/')
        let items = []

        for (let path of paths) {
            if (path === 'new-architecture') {
                items.push({text: 'Architectures', href: '/'})
                items.push({text: 'New architecture', href: '/new-architecture'})
            }
            else if (path !== 'architectures' && path !== 'CANVAS' && path !== '#' && path !== '') {
                items.push({text: 'Architectures', href: '/'})
                items.push({text: path, href: `/architectures/${path}`})
            }
            else if (path !== 'architectures' && path !== '#' && path !== '') {
                items.push({text: 'Architectures', href: '/'})
                items.push({text: 'New architecture', href: `/architectures/${path}`})
            }
        }

        if (items.length > 0) {
            return (
                <BreadcrumbGroup
                    items={items}
                    onFollow={e => {
                        e.preventDefault();
                        navigate(e.detail.href);
                    }}
                />
            )
        }

        return null
    }

    return (
        <>
            <div id="h" style={{position: 'sticky', top: 0, zIndex: 1002}}>
                <TopNavigation
                    identity={{
                        href: '#',
                        title: 'Intelligent architecture generator',
                    }}
                    utilities={[
                        {
                            type: 'menu-dropdown',
                            text: auth.user.profile.email,
                            iconName: 'user-profile',
                            onItemClick: handleButtonClick,
                            items: [
                                {
                                    id: 'signout',
                                    text: 'Sign out',
                                }
                            ],
                        },
                    ]}
                />
            </div>
            <AppLayoutToolbar
                headerSelector={'#h'}
                navigationHide={true}
                toolsHide={true}
                breadcrumbs={buildBreadcrumbs()}
                content={<Outlet/>}
                {...props}
            />
        </>
    )
}
